import {
    CHECK_LOGIN,
    LOGIN_USER_SUCCESSFUL,
    API_ERROR,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
} from "./actionTypes";

const initialState = {
    loading: false,
    loginError: null,
    user: null,
};

const login = (state = initialState, action) => {
    switch (action.type) {
        case CHECK_LOGIN:
            return { ...state, loading: true, loginError: null };

        case LOGIN_USER_SUCCESSFUL:
            return { ...state, loading: false, user: action.payload };

        case API_ERROR:
            return { ...state, loading: false, loginError: action.payload };

        case LOGOUT_USER:
            return { ...state, loading: true };

        case LOGOUT_USER_SUCCESS:
            return { ...state, loading: false, user: null };

        default:
            return state;
    }
};

export default login;